import React, { useEffect, useState, useCallback, forwardRef } from 'react';
import { MapService } from '../services/map-service';
import { useParams } from "react-router-dom";
//import { useLocation } from "react-router-dom";
import moment from 'moment';
import GeneralTable from "../components/layouts/general-table";
import TitleGrows from "../components/title-grows";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import IconButton from '@mui/material/IconButton';
import Snackbar from '@mui/material/Snackbar';
import MuiAlert from '@mui/material/Alert';
import { useFormik } from 'formik';

import MultipleSelectedArticles from '../components/widgets/multiple-selected-articles';

const allOriginDomain = [
    "None",
    "All_domain",
    "www",
    "impact",
    "cybersecurity",
    "ischool",
    "openinnovation",
    "smartworking",
    "smartmoney",
    "sportup",
    "thefoodmakers",
    "thenexttech",
    "valoreresponsabile",
    "life",
];

export default function Map() {

    // function useQuery() {
    //     const { search } = useLocation();
    //     return React.useMemo(() => new URLSearchParams(search), [search]);
    // }
    const { id } = useParams();
    //let query = useQuery();
    //const [resultsList, setResultsList] = useState([]);
    //const [regions, setRegions] = useState([]);
    const [showMultipleSelectedArticles, setShowMultipleSelectedArticles] = useState(false);
    const [isLoading, setIsLoading] = useState(false);
    // const [map, setMap] = useState({
    //     title: query.get("title"),
    //     description: query.get("description")
    // });
    const [map, setMap] = useState({
        title: '',
        description: ''
    });
    const [pages, setPages] = useState([]);
    const [selected, setSelected] = useState([]);
    const [itemsCount, setItemsCount] = useState(0);
    const [errors, setErrors] = useState([]);

    //Formik
    const formik = useFormik({
        initialValues: map,
        enableReinitialize: true,
        onSubmit: values => {
            alert(JSON.stringify(values, null, 2));
        },
    });

    const cols = [
        { label: 'ID', key: 'id', isSortable: true, isVisible: true, },
        { label: 'TITLE', key: 'title', isSortable: true, isVisible: true, },
        { label: 'DESCRIPTION', key: 'description', isSortable: false, isVisible: true, },
        { label: 'REGION NAME', key: 'region_name', isSortable: false, isVisible: true, },
        {
            label: 'UPDATE',
            key: 'updated',
            isSortable: true,
            isVisible: true,
            render: (col, row) => {
                return moment(row.updated).locale("it").format(`D MMMM YYYY HH:MM`);
            }
        },
        {
            label: 'EDIT POSTS',
            key: 'action',
            isSortable: false,
            isVisible: true,
            render: (col, row) => {
                return (
                    <>
                        <span style={{ color: row.posts.length === 0 && '#dc3545' }}>({row.posts.length})</span>
                        <IconButton
                            onClick={() => { setSelected(row); setShowMultipleSelectedArticles(true); }}
                            edge="end" aria-label="edit"
                            style={{ margin: "2px" }}
                        >
                            <FontAwesomeIcon icon={['fas', 'edit']} size={'1x'} color={'#0D6EFD'} title={'Aggiungi/Elimina/Riordina i posts'} />
                        </IconButton>
                    </>
                );
            }
        },
    ]

    const [state, setState] = useState({
        open: false,
        vertical: 'top',
        horizontal: 'center',
        message: '',
        severity: 'success',
        ahduration: 3000,
        instructions: ''
    });

    const { open, vertical, horizontal, message, severity, ahduration, instructions } = state;
    const Alert = forwardRef(function Alert(props, ref) {
        return <MuiAlert elevation={6} ref={ref} variant="filled" {...props} />;
    });

    const handleChanges = (tableParams) => {
        getData(id, tableParams)
    };

    const getData = useCallback(async (id, params = {}) => {

        setIsLoading(true);
        // setPages([])
        // setItemsCount(0)
        const {
            page = 1, page_size = 25, ordering = 'title'
        } = params
        let _params = {
            page: page,
            page_size: page_size,
            ordering: ordering
        }

        try {
            let resMap = await MapService.getSingle(id);
            if (!resMap || (resMap?.status && resMap?.status !== 200)) {
                console.log(`Error getSingle: `, resMap);
                setPages([])
                setItemsCount(0)
                setIsLoading(false);
                setErrors(`Error getSingle: ${resMap?.statusText} - (status ${resMap?.status})`)
                return {
                    revalidate: 5,
                    notFound: true,
                }
            }

            setMap({
                title: resMap.data.title,
                description: resMap.data.description
            })
            let resSections = await MapService.getSections(id, _params);

            if (!resSections || (resSections?.status && resSections?.status !== 200)) {
                console.log(`Error getList: `, resSections);
                setPages([])
                setItemsCount(0)
                setIsLoading(false);
                setErrors(`Error getList: ${resSections?.statusText} - (status ${resSections?.status})`)
                return {
                    revalidate: 5,
                    notFound: true,
                }
            }
            if (resSections.count > 0) {
                setItemsCount(resSections.count)
                setPages(resSections.results)
                setIsLoading(false);
            }
            else {
                setErrors(`Nessun sezione trovata!`)
                setIsLoading(false);
            }
        } catch (e) {
            console.log(e);
            return {
                revalidate: 5,
                notFound: true,
            }
        }
    }, [])

    useEffect(() => {
        const delayDebounceFn = setTimeout(() => {
            getData(id);
        }, 250)
        return () => {
            clearTimeout(delayDebounceFn)
            setIsLoading(false);
            setPages([])
        }
        // eslint-disable-next-line
    }, []);

    function handleUpdateData(mapSection, section_id) {
        //console.log('mapSection: ', mapSection, section_id)

        if (mapSection !== null && section_id !== -1) {
            selected.posts = mapSection.posts
            const postIdList = mapSection.posts.map((post, index) => (
                post.id
            ));
            saveSectionPost(id, section_id,
                {
                    title: mapSection.title,
                    description: mapSection.description,
                    posts_ids: postIdList
                },)
        }
        setSelected([])
        setShowMultipleSelectedArticles(false);
    }

    async function saveMap(id) {

        let imsg = null;
        let data = formik.values;

        try {
            let resObject = await MapService.update(id, data);

            if (!resObject || (resObject?.status && resObject?.status !== 200)) {
                console.log(`Error update map: `, resObject);
                setErrors(`Error update map: ${resObject?.statusText} - (status ${resObject?.status})`)
                setState({
                    open: true,
                    vertical: 'top',
                    horizontal: 'center',
                    message: 'Errore, non è stato possibile salvare!',
                    severity: 'error',
                    ahduration: null,
                    instructions: imsg
                });
                return {
                    revalidate: 5,
                    notFound: true,
                }
            }
            setState({
                open: true,
                vertical: 'top',
                horizontal: 'center',
                message: 'Salvato correttamente!',
                severity: 'success',
                ahduration: 2000,
                instructions: null
            })
        } catch (e) {
            console.log(e);
            return {
                revalidate: 5,
                notFound: true,
            }
        }
    }

    async function saveSectionPost(id, section_id, params) {

        let imsg = null;

        try {
            let resObject = await MapService.updateSectionPosts(id, section_id, params);

            if (!resObject || (resObject?.status && resObject?.status !== 200)) {
                console.log(`Error update posts map: `, resObject);
                setErrors(`Error update posts map: ${resObject?.statusText} - (status ${resObject?.status})`)
                setState({
                    open: true,
                    vertical: 'top',
                    horizontal: 'center',
                    message: 'Errore, non è stato possibile salvare!',
                    severity: 'error',
                    ahduration: null,
                    instructions: imsg
                });
                return {
                    revalidate: 5,
                    notFound: true,
                }
            }
            setState({
                open: true,
                vertical: 'top',
                horizontal: 'center',
                message: 'Posts salvati correttamente!',
                severity: 'success',
                ahduration: 2000,
                instructions: null
            })
            getData(id)
        } catch (e) {
            console.log(e);
            return {
                revalidate: 5,
                notFound: true,
            }
        }
    }

    const handleClose = () => {
        setState({ ...state, open: false });
    };

    return (
        <>
            <div className='d-flex flex-column h-100'>
                <div className='flex-grow-0'>
                    <TitleGrows txtTitle="Map Section List" />
                </div>
                <>
                    <div className="row border rounded-2 m-2">
                        <div className="col-11 border-end">
                            <div className="card-body">
                                <div className="card-title">
                                    <div className="row" style={{ justifyContent: "center" }}>
                                        <div className="col-12">
                                            <span className="fw-bold">
                                                Title:</span>

                                            <input type="text" id="title" className="form-control" style={{ width: "100%", border: errors?.title ? "2px solid red" : '' }}
                                                onChange={formik.handleChange}
                                                value={formik.values.title}
                                            />
                                        </div>
                                    </div>
                                </div>
                                <div className="card-title">
                                    <div className="row" style={{ justifyContent: "center" }}>
                                        <div className="col-12">
                                            <span className="fw-bold">
                                                Description:</span>

                                            <input type="text" id="description" className="form-control" style={{ width: "100%", border: errors?.description ? "2px solid red" : '' }}
                                                onChange={formik.handleChange}
                                                value={formik.values.description}
                                            />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="col-1 m-auto d-flex justify-content-center">
                            <button type="button" onClick={() => { saveMap(id); }} className="btn btn-primary"
                                data-bs-toggle="tooltip" data-bs-placement="bottom" title="Salva titolo e descrizione"
                                style={{ width: "4rem" }}>Salva</button>
                            {/* <span style={{ color: "red", float: "right" }}>
                                    <FontAwesomeIcon icon={['fas', 'asterisk']} size={'1x'} color={'red'} />
                                    <span className="user-select-none">Indica un campo obbligatorio</span>
                                </span> */}
                        </div>
                    </div>
                    {errors.length > 0 ? <div>{errors}</div>
                        : <div className='flex-grow-1'>
                            <GeneralTable
                                cols={cols}
                                data={pages}
                                itemsCount={itemsCount}
                                isLoading={isLoading}
                                initialOptions={
                                    { initialPageSize: 25, initialOrdering: { key: 'title', asc: true } }
                                }
                                handleChanges={handleChanges}
                            // generalOptions={{ rowsPerPageOptions: [1, 2, 10, 25, 50] }}
                            />
                            {showMultipleSelectedArticles && <MultipleSelectedArticles onUpdate={handleUpdateData}
                                index={selected.id} widget={[{ data: [selected] }]} _kind={'post'} _all_origin_domain={allOriginDomain}
                                detail={selected.region_name} isMapSection={true} />}
                        </div>
                    }
                </>
                <Snackbar open={open} autoHideDuration={ahduration} onClose={handleClose}
                    anchorOrigin={{ vertical, horizontal }} >
                    <Alert onClose={handleClose} severity={severity} sx={{ width: '100%' }}>
                        <div style={{ textAlign: "center" }}>{message}</div>
                        {instructions ?
                            <div style={{ margin: "10px 0 0 0" }}>
                                {instructions}
                            </div>
                            : ''}
                    </Alert>
                </Snackbar>
            </div>
        </>
    );
}